// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__16yhh","buttons":"RemoveExpirationActionButtons_buttons__1RSjV"};